import React, { useState } from "react";
import styled from "styled-components";
import Text from "../../../components/Common/Text";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomInput from "../../../components/CustomForm/CustomInput";
import { isEmptyValue } from "../../../utils/StringUtil";
import Colors from "../../../themes/Colors";

const ScrollableContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const InstructionText = styled(Text)`
  color: ${Colors.grayFont};
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

const ErrorText = styled(Text)`
  color: #ff0000;
  font-size: 14px;
  margin-top: 8px;
`;

const MedicamentosModal = ({
  query,
  onQueryChange,
  onSearch,
  columnsMedicamentos,
  dataMedicamentos,
  itemsPerPage,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleQueryChange = (value) => {
    // Limpiar el error cuando el usuario escribe
    if (errorMessage) {
      setErrorMessage("");
    }
    const upperValue = value ? value.toUpperCase() : value;
    onQueryChange()(upperValue);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const trimmedQuery = query?.trim() || "";
      
      if (isEmptyValue(trimmedQuery)) {
        setErrorMessage("Debe ingresar el nombre del medicamento a buscar");
        return;
      }
      
      setErrorMessage("");
      if (onSearch) {
        onSearch(trimmedQuery);
      }
    }
  };

  return (
    <div>
      <Text size="24px" isTittle={true} weight={"bold"}>
        {"Agregar Medicamento"}
      </Text>

      <InstructionText>
        Debe ingresar el nombre del medicamento o iniciales y luego presionar enter.
      </InstructionText>

      <CustomInput
        type={"text"}
        placeholder={"Buscar por nombre o código"}
        value={query}
        onChange={handleQueryChange}
        handleKeyPress={handleKeyPress}
      />

      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}

      <CustomSeparator height={"10px"} />

      <ScrollableContainer>
        <CustomTable
          columns={columnsMedicamentos}
          dataSource={dataMedicamentos}
          showPagination={false}
          pageSize={itemsPerPage}
        />
      </ScrollableContainer>
    </div>
  );
};

export default MedicamentosModal;